import { CreditUsageButtonProps } from 'blaze-ui/CreditUsageButton/Types'
import { forwardRef } from 'react'
import { Button } from 'blaze-ui/Button'
import { Credits } from 'blaze-ui/icons/20/Credits'
import Styles from './CreditUsageButton.module.scss'

export const CreditUsageButton = forwardRef<HTMLButtonElement, CreditUsageButtonProps>(
  ({ credits, children, color, ...props }, fRef) => {
    return (
      <Button
        ref={fRef}
        {...props}
        endIcon={() => (
          <>
            <Credits size={16} color={color} />
            <span className={Styles.credits} style={{ color }}>
              {credits}
            </span>
          </>
        )}
      >
        {children}
      </Button>
    )
  },
)
